<div class="grid-container">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--large">Update TSP Rate</legend>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label">
        The process of transferring rates from the current period to the next period can ONLY be chosen once, so
        consider your choice carefully.
      </label>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label">TSP: {{carrier? carrier.scac : 'N/A'}} - {{carrier ? carrier.scacName :
        'N/A'}}</label>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label">Records in current rate cycle: {{this.ratesCount? this.ratesCount : 0}}</label>
        </div>
    </div>
    <form [formGroup]="rateCarryOver" *ngIf="showForm">
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label">SRO's in selected bidcycle:</label>
                <select multiple id="sro_type" class="usa-select define-height-usa-select maxw-full" size="5" formControlName="sroMasterId" (change)="sroTypeChange($event.target.value)">
                  <option [value]="-1">All</option>
                  <option [ngValue]="sro.sroMasterId" *ngFor="let sro of agencies">{{sro.sroId}}</option>
                </select>
            </div>
        </div>
    </form>
    <div class="grid-row padding-top-4">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            I would like to transfer all the rates in the current rate cycle to the next rate cycle:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ul class="usa-button-group">
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button" [disabled]="this.disableAcceptBtn" (click)="acceptCarryOver()">Accept</button>
                </li>
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button usa-button--secondary" (click)="rejectCarryOver()">Reject</button>
                </li>
            </ul>
        </div>
    </div>
</div>